import axios from 'axios';

export const getProcurementDemand = () =>
  axios.get('/api/v1/admin/procurement', {
    headers: { Authorization: localStorage.getItem('token') },
  });
